'use strict';

module Patersons {

    export class ChangeRequestService extends BaseService {
        getChangeRequests() {
            return this.get("/dataService/odata/changeRequests");
        }

        getChangeRequestsForApproval() {
            return this.get("/dataService/odata/changeRequests/ChangeRequestService.GetChangeRequestsForApproval");
        }

        approveChangeRequest(changeRequestId: number, verificationCode: string) {
            return this.post('/dataService/odata/changeRequests(' + changeRequestId + ')/ChangeRequestService.ApproveChangeRequest', { smsToken: verificationCode });
        };

        rejectChangeRequest(changeRequestId: number) {
            return this.post('/dataService/odata/changeRequests(' + changeRequestId + ')/ChangeRequestService.RejectChangeRequest', null);
        };

        areAllAccountApproversRegistered(accountCode: string) {
            return this.get("/dataService/api/portfolios/" + accountCode + "/AreAllAccountApproversRegistered");
        };

        getAccountApproversCount(accountCode: string) {
            return this.get("/dataService/api/portfolios/" + accountCode + "/GetAccountApproversCount");
        };
    }
}